export default "__VITE_ASSET__BSrScknC__"